import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { AuthConsumer } from '../context/AuthContext';

// component for right side bar
class SideBar extends React.Component {
	componentDidMount() {
		const jQuery = window.jQuery || window.$;

		// convert svg in image path to convas
		jQuery('img.svg').each(function () {
			var $img = jQuery(this);
			var imgID = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL = $img.attr('src');

			jQuery.get(
				imgURL,
				function (data) {
					// Get the SVG tag, ignore the rest
					var $svg = jQuery(data).find('svg');

					// Add replaced image's ID to the new SVG
					if (typeof imgID !== 'undefined') {
						$svg = $svg.attr('id', imgID);
					}
					// Add replaced image's classes to the new SVG
					if (typeof imgClass !== 'undefined') {
						$svg = $svg.attr('class', imgClass + ' replaced-svg');
					}

					// Remove any invalid XML tags as per http://validator.w3.org
					$svg = $svg.removeAttr('xmlns:a');

					// Replace image with new SVG
					$img.replaceWith($svg);
				},
				'xml'
			);
		});
	}

	render() {
		let loginData = window.localStorage.getItem('uniabuja-login-data');
		return (
			//  right side bar
			<div className="side-bar col-12 col-xs-3 col-sm-4 col-md-3 col-lg-2 col-xl-2 p-0">
				<aside>
					<nav
						className="navbar navbar-expand-sm navbar-light bg-transparent align-items-start flex-sm-column flex-row"
						id="navbar"
					>
						<a className="navbar-brand d-none d-sm-block " href="/">
							<img
								src={require('../assets/logo_school.png')}
								alt="University logo"
								width={230}
								height="auto"
							/>
						</a>
						<a
							href="void(0)"
							className="navbar-toggler m-3 "
							data-toggle="collapse"
							data-target=".sidebar"
						>
							<span className="navbar-toggler-icon" />
						</a>
						<div className="collapse navbar-collapse sidebar w-100">
							<ul className="flex-column navbar-nav w-100 justify-content-between">
								<li className="nav-item">
									<NavLink to="/" className="nav-link" href="#">
										<img
											src={require('../assets/dashboard.svg')}
											height={20}
											width={20}
											className="svg"
											alt="Dashboard"
										/>
										<span className="">Dashboard</span>
									</NavLink>
								</li>
								<li className="nav-item">
									<a
										className="nav-link dropdown-toggle text-nowrap"
										href="#"
										data-parent="#navbar"
										data-toggle="collapse"
										data-target="#m1"
										aria-expanded="false"
									>
										<img
											src={require('../assets/courses.svg')}
											height={20}
											width={20}
											className="svg"
											alt="Courses"
										/>
										<span className="">Courses</span>
									</a>
									<div className="collapse" id="m1">
										<ul className="flex-column nav">
											<NavLink
												className="nav-link px-0 text-truncate"
												to="/courses"
											>
												Register Courses
											</NavLink>
											<NavLink
												className="nav-link px-0 text-truncate"
												to="/courses/registered"
											>
												Registered Courses
											</NavLink>
											{/*<AuthConsumer>
                        {({ user }) => (
                          <a
                            className="nav-link px-0 text-truncate"
                            target="_blank"
                            href={`https://ug.infosys.uniabuja.edu.ng/generate/examdocket/print/${
                              user.id
                            }/first`}
                          >
                            Print Exam Docket
                          </a>
                        )}
                      </AuthConsumer>*/}
											{/* <a
												className="nav-link px-0 text-truncate"
												target="_blank"
												href="https://dlclms.ui.edu.ng/"
											>
												LMS
											</a> */}
											{/* <a
												className="nav-link px-0 text-truncate"
												target="_blank"
												href="http://www.dlc.ui.edu.ng/"
											>
												DLC Website
											</a> */}
											<a
												className="nav-link px-0 text-truncate"
												target="_blank"
												href="https://demo7.dspace.org/"
											>
												E-Library
											</a>
										</ul>
									</div>
								</li>
								{/* <li className="nav-item">
									<NavLink to="result" className="nav-link" href="#">
										<img
											src={require('../assets/result.svg')}
											height={20}
											width={20}
											className="svg"
											alt="Result"
										/>
										<span className="">Result</span>
									</NavLink>
								</li> */}
								<li className="nav-item">
									<NavLink to="/fees" className="nav-link" href="#">
										<img
											src={require('../assets/fees.svg')}
											height={20}
											width={20}
											className="svg"
											alt="Fees"
										/>
										<span className="">Fees</span>
									</NavLink>
								</li>
								<li className="nav-item">
									<NavLink to="/transactions" className="nav-link" href="#">
										<img
											src={require('../assets/transactions.svg')}
											height={20}
											width={20}
											className="svg"
											alt="Transactions"
										/>
										<span className="">Transactions</span>
									</NavLink>
								</li>
								<li>
									<NavLink to="/prints" className="nav-link" href="#">
										<img
											src={require('../assets/print.svg')}
											height={20}
											width={20}
											className="svg"
											alt="Transactions"
										/>
										<span className="">Prints</span>
									</NavLink>
								</li>
								<li className="nav-item">
									<NavLink to="/accomodations" className="nav-link" href="#">
										<img
											src={require('../assets/accomodation.svg')}
											height={20}
											width={20}
											className="svg"
											alt="Transactions"
										/>
										<span className="">Accomodations</span>
									</NavLink>
								</li>
								<AuthConsumer>
									{({ logout }) => (
										<li className="nav-item">
											<NavLink
												to="/"
												className="nav-link"
												href="#"
												onClick={(e) => logout()}
											>
												<img
													src={require('../assets/print.svg')}
													height={20}
													width={20}
													className="svg"
													alt="Logout"
												/>
												<span className="">Logout</span>
											</NavLink>
										</li>
									)}
								</AuthConsumer>
								{/* <li className="nav-item">
                <a
                  className="nav-link dropdown-toggle text-nowrap"
                  href="#m1"
                  data-parent="#navbar"
                  data-toggle="collapse"
                  data-target="#m1"
                  aria-expanded="false"
                >
                  <img
                    src={require("../assets/more.svg")}
                    height={20}
                    width={20}
                    className="svg"
                    alt="More"
                  />
                  <span className="">More</span>
                </a>
                <div className="collapse" id="m1">
                  <ul className="flex-column nav">
                    <a className="nav-link px-0 text-truncate" href="#">
                      Sub
                    </a>
                    <a className="nav-link px-0 text-truncate" href="#">
                      Sub longer
                    </a>
                  </ul>
                </div>
              </li> */}
							</ul>
						</div>
					</nav>
				</aside>
				<script src={require('../js/main.js')}> </script>
			</div>
		);
	}
}

export default SideBar;
